import React from "react";
import { Disclosure } from "@headlessui/react";
import { twClassNames } from "../../../../helpers/twClassNames";
import Button from "../../../Button";
import { NumberedStep } from "./NumberedStep";
import { BodyText } from "./BodyText";
import { MarkdownPreview } from "../../../MarkdownPreview";

export function LocalInferenceInstallationStep({
    number = 1,
    collapsible = true
}: {
    number?: number;
    collapsible?: boolean;
}) {
    return (
        <NumberedStep number={number} title="Install the Server" collapsible={collapsible}>
            <div className="flex flex-col gap-2">
                <BodyText>Download our software on your computer to start a local server.</BodyText>
                <div className="flex w-full gap-2">
                    <Button
                        type="secondary"
                        className="flex-1 justify-start"
                        onClick={() => {
                            window.open("https://inference.roboflow.com/download", "_blank");
                        }}
                    >
                        MacOS
                    </Button>
                    <Button
                        type="secondary"
                        className="flex-1 justify-start"
                        onClick={() => {
                            window.open("https://inference.roboflow.com/download", "_blank");
                        }}
                    >
                        Windows
                    </Button>
                </div>
                <div className="mt-4">
                    <Disclosure>
                        {({ open }) => (
                            <div>
                                <Disclosure.Button className="flex w-full items-center justify-between text-left">
                                    <h4 className="text-sm font-medium text-secondary">
                                        You can also install directly in your terminal
                                    </h4>
                                    <i
                                        className={twClassNames(
                                            open ? "fa-chevron-down" : "fa-chevron-up",
                                            "fas size-5"
                                        )}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="mt-2">
                                    <BodyText>
                                        Install our latest inference package and run the following
                                        command (see full documentation{" "}
                                        <a
                                            href="https://inference.roboflow.com/quickstart/run_a_model/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            here
                                        </a>
                                        ):
                                    </BodyText>
                                    <div className="overflow-x-auto rounded-lg border border-gray-200">
                                        <MarkdownPreview
                                            source={`\`\`\`bash
pip install -U inference-cli && inference server start
\`\`\``}
                                            sanitize={false}
                                        />
                                    </div>
                                    <p className="mt-2 text-xs text-gray-600">
                                        Requires inference package version {">="}
                                        0.9.18.
                                    </p>
                                </Disclosure.Panel>
                            </div>
                        )}
                    </Disclosure>
                </div>
            </div>
        </NumberedStep>
    );
}
